import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { globalStyles as styles } from './style/gstheme';

class KebabMenu extends Component {

    state = {
        anchorEl: null
    }

    handleClick = (event) => this.setState({ anchorEl: event.currentTarget });

    handleClose = (itemIndex) => {
        this.setState({ anchorEl: null });
        if (itemIndex !== null) this.props.onSelect(itemIndex);
    }

    render() {

        const { anchorEl } = this.state;
        const { items, colour, dataTest } = this.props;

        return (
            <div data-test={dataTest || "inline-menu"}>
                <IconButton size="small"
                    style={{ ...(colour) && { color: colour } }}
                    onClick={(ev) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        this.handleClick(ev);
                    }}>
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id="simple-menu"
                    data-test="kebab-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={(ev) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        this.handleClose(null);
                    }}>
                    {Boolean(anchorEl) && items.map((item, index) =>
                        <MenuItem key={index}
                            data-test={dataTest ? dataTest + "-" + item : "inline-menu-" + item}
                            onClick={(ev) => {
                                ev.preventDefault();
                                ev.stopPropagation();
                                this.handleClose(index);
                            }}>
                            <div data-test={"kebab-item-" + index}>
                                {item}
                            </div>
                        </MenuItem>)}
                </Menu>
            </div >
        );
    }
}

KebabMenu.propTypes = {
    dataTest: PropTypes.string,
    items: PropTypes.array.isRequired,
    colour: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(KebabMenu);